import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import config from "../common/Config";
import * as XLSX from 'xlsx';
import ManageColumns from "../tableComponents/manageColumns/ManageColumns";
import FallbackManageColumns from "../tableComponents/manageColumns/FallbackManageColumns";
import StandaloneManageColumnsModal from "../tableComponents/manageColumns/StandaloneManageColumnsModal";
import { setTableWidths, getTableWidths } from "../../data/postAPi";
import CommonDatePicker from '../datepicker/CommonDatePicker';

const SalesOrderReport = () => {
    const [reportrange, setReportrange] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [reportDate, setReportDate] = useState('');
    const salesOrderRef = useRef(null);
    const [salesRapOptions, setSalesRapOptions] = useState([]);
    const [salesRap, setSalesRap] = useState('');
    const [routeOptions, setRouteOptions] = useState([]);
    const [salesRoute, setSalesRoute] = useState('');
    const [recordsTotal, setRecordsTotal] = useState('');
    const [totals, setTotals] = useState({
        netAmount: 0,
        taxTotal: 0,
        grandTotal: 0,
        paidTotal: 0
    });
    const accessToken = localStorage.getItem('accessToken');
    const currencySymbol = localStorage.getItem("currencySymbol");
    const company_tax_type = localStorage.getItem("company_tax_type");

    // Column resizing state
    const [colWidths, setColWidths] = useState([80, 100, 200, 120, 120, 120, 120, 120]);
    const userId = localStorage.getItem("userId");
    const tableName = "salesOrderReportTable";

    // Debounce function for setting table widths
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    const debouncedSetTableWidths = useRef(
        debounce((userId, tableName, widths) => {
            setTableWidths(userId, tableName, widths);
        }, 500)
    ).current;

    // Column resizing handler
    const startResizing = (index, e) => {
        e.preventDefault();
        const startX = e.clientX;
        const startWidth = colWidths[index];
        const onMouseMove = (moveEvent) => {
            const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
            setColWidths((widths) => {
                const updated = [...widths];
                updated[index] = newWidth;
                debouncedSetTableWidths(userId, tableName, updated);
                return updated;
            });
        };
        const onMouseUp = () => {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    };
    const fetchWidths = async () => {
        try {
            const res = await getTableWidths(userId, tableName);
            if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
                setColWidths(res.data.widths);
            } else {
                setColWidths([80, 100, 200, 120, 120, 120, 120, 120]);
            }
        } catch (e) {
            setColWidths([80, 100, 200, 120, 120, 120, 120, 120]);
        }
    }
    // Load saved column widths on component mount
    useEffect(() => {
        async function fetchWidths() {
            try {
                const res = await getTableWidths(userId, tableName);
                if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
                    setColWidths(res.data.widths);
                } else {
                    setColWidths([80, 100, 200, 120, 120, 120, 120, 120]);
                }
            } catch (e) {
                setColWidths([80, 100, 200, 120, 120, 120, 120, 120]);
            }
        }
        fetchWidths();
    }, []);

    const handleDateChange = (value) => {
        setDates(value);
        let startDate = value[0] ? format(value[0], 'MM/dd/yyyy') : '';
        let endDate = value[1] ? format(value[1], 'MM/dd/yyyy') : '';
        setReportrange(startDate ? startDate + ' - ' + endDate : '');
        setReportDate(startDate + ' To Date : ' + endDate);
    };

    const fetchSalesRapOptions = async () => {
        const apiSalesRapUrl = `${config.API_URL}/getSalesRep`;
        try {
            const response = await fetch(apiSalesRapUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                }
            });
            const data = await response.json();
            const formattedOptions = data.data.map(item => ({
                label: `${item.first_name} ${item.last_name}`,
                value: item.id,
            }));
            setSalesRapOptions(formattedOptions);
        } catch (error) {
            console.error('Error fetching Sales Rep:', error);
        }
    };

    const fetchSalesRoute = async () => {
        const apiSalesRouteUrl = `${config.API_URL}/getRoute`;
        try {
            const response = await fetch(apiSalesRouteUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                }
            });
            const data = await response.json();
            const formattedOptions = data.data.map(item => ({
                label: `${item.route_number}`,
                value: item.id,
            }));
            setRouteOptions(formattedOptions);
        } catch (error) {
            console.error('Error fetching sales routes');
        }
    };

    const fetchReport = () => {
        const $table = $(salesOrderRef.current);
        const searchValue = $('#searchValue').val();

        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }

        // Set totals and currency symbol on window for DataTable footerCallback
        window.salesOrderTotals = totals;
        window.salesOrderCurrencySymbol = currencySymbol;
        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.API_URL}/ws-SalesOrder-report`,
                type: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                data: function (d) {
                    return $.extend({}, d, {
                        draw: d.draw,
                        start: d.start,
                        length: d.length,
                        searchValue: searchValue,
                        reportrange: reportrange,
                        sales_rep: salesRap,
                        route_id: salesRoute,
                        authorization: `Bearer ${accessToken}`,
                    });
                },
                dataSrc: function (json) {
                    if (json && json.data && Array.isArray(json.data)) {
                        setRecordsTotal(json.recordsTotal);
                        setReportDate(json.startdate + ' To Date : ' + json.enddate);
                
                        // Calculate totals
                        const netAmount = parseFloat(json.sum_total_net || 0);
                        const taxTotal = parseFloat(json.sum_total_tax || 0);
                        const grandTotal = parseFloat(json.sum_grand_total || 0);
                        const paidTotal = parseFloat(json.sum_total_paid || 0);

                        const calculatedTotals = { netAmount, taxTotal, grandTotal, paidTotal };
                
                        setTotals(calculatedTotals);
                
                        // Set window variable here for immediate use in footerCallback
                        window.salesOrderTotals = calculatedTotals;
                        window.salesOrderCurrencySymbol = currencySymbol;
                    }
                    return Array.isArray(json.data) ? json.data : [];
                },
            },
            language: {
                paginate: {
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    previous: 'Previous',
                },
                search: 'Search:',
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1;
                    }
                },
                { data: 'date' },
                {
                    data: "company",
                    render: (data, type, row) => {
                        const company = row.company || '';
                        const accountNo = row.accound_no || '';
                        return `${company} (${accountNo})`;
                    },
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return '<a href="' + config.BASE_URL + '/reports/mis_report/print/' + row.id + '">' + row.reference_no + '</a>';
                    }
                },
                {
                    data: 'net_amount',
                    render: function (data, type, row) {
                        return currencySymbol + ' ' + parseFloat(data || 0).toFixed(2);
                    }
                },
                {
                    data: 'total_tax',
                    render: function (data, type, row) {
                        return currencySymbol + ' ' + parseFloat(data || 0).toFixed(2);
                    }
                },
                {
                    data: 'grand_total',
                    render: function (data, type, row) {
                        return currencySymbol + ' ' + parseFloat(data || 0).toFixed(2);
                    }
                },
                {
                    data: 'paid',
                    render: function (data, type, row) {
                        return currencySymbol + ' ' + parseFloat(data || 0).toFixed(2);
                    }
                },
            ],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5],
                    orderable: false
                }
            ],
            pageLength: 50,
            footerCallback: function (row, data, start, end, display) {
                // Use the React state totals for the overall totals
                // Access the totals from the window object (set before DataTable init)
                const currencySymbol = window.salesOrderCurrencySymbol || '';
                const totals = window.salesOrderTotals || { netAmount: 0, taxTotal: 0, grandTotal: 0, paidTotal: 0 };

                $(this.api().column(4).footer()).html(currencySymbol + ' ' + parseFloat(totals.netAmount).toFixed(2));
                $(this.api().column(5).footer()).html(currencySymbol + ' ' + parseFloat(totals.taxTotal).toFixed(2));
                $(this.api().column(6).footer()).html(currencySymbol + ' ' + parseFloat(totals.grandTotal).toFixed(2));
                $(this.api().column(7).footer()).html(currencySymbol + ' ' + parseFloat(totals.paidTotal).toFixed(2));
            }
        });
    };

    useEffect(() => {
        if (accessToken === null) {
            window.location.href = `${config.BASE_URL}/login`;
            return;
        }
        fetchReport();
        fetchSalesRapOptions();
        fetchSalesRoute();
    }, []);

    const searchFormData = () => {
        fetchReport();
        fetchWidths();
    };

    const handleOptionChange = (event) => {
        setSalesRap(event.target.value);
    };

    const handleChangeRoute = (event) => {
        setSalesRoute(event.target.value);
    };

    const exportToExcel = async () => {
        const searchValue = $('#searchValue').val();
        const formData = new FormData();
        formData.append('draw', '1');
        formData.append('start', '0');
        formData.append("length", recordsTotal);
        formData.append("searchValue", searchValue);
        formData.append("reportrange", reportrange);
        formData.append("sales_rep", salesRap);
        formData.append("route_id", salesRoute);
        formData.append("authorization", `Bearer ${accessToken}`);

        const apiActivePdtUrl = `${config.API_URL}/ws-SalesOrder-report`;

        try {
            const response = await fetch(apiActivePdtUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }

            const data = await response.json();
            const exportData = data.data.map(product => ({
                Date: product.date || '',
                "Customer (A/C)": product.company
                    ? `${product.company} (${product.accound_no || ''})`
                    : product.accound_no || '',
                "Order Number": product.reference_no || '',
                "Net Amount": parseFloat(product.net_amount || 0),
                [`${company_tax_type} Total`] : parseFloat(product.total_tax || 0),
                "Grand Total": parseFloat(product.grand_total || 0),
                "Paid Total": parseFloat(product.net_amount || 0)
                // "Status": product.sale_status || ''
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);

            // Set column widths
            const colWidths = [
                { wch: 12 }, // Date
                { wch: 25 }, // Customer
                { wch: 15 }, // Order Number
                { wch: 12 }, // Net Amount
                { wch: 12 }, // Tax Total
                { wch: 12 }, // Grand Total
                { wch: 12 }, // Paid Total
                { wch: 10 }  // Status
            ];
            ws['!cols'] = colWidths;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sales Order Report');

            const now = new Date();
            const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            const filename = `Sales-Order-Report-${formattedDate}-${formattedTime}.xlsx`;

            XLSX.writeFile(wb, filename);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            alert("Error exporting to Excel. Please try again.");
        }
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports">Reports</Link>
                            <Link to="#">Sales Order Report</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container position-relative">
                <div className="container-fluid">
                    <div className="dashboard">
                        <div className="row sales-order-report-filter">
                            <div className="col-sm-4 col-md-4 col-lg-4">
                            <CommonDatePicker value={dates} onChange={handleDateChange} />

                            </div>

                            <div className="col-md-3 col-lg-3 col-sm-4" style={{ float: 'left' }}>
                                <button type="button" onClick={searchFormData} className="acceptbtn"
                                    style={{ float: 'left' }}
                                >
                                    Submit
                                </button>
                                <button className="create-catalogue-btn" onClick={exportToExcel} style={{ textTransform: 'capitalize' }}>
                                    Export Excel
                                </button>
                            </div>

                        </div>

                        <div className="verical-scrl-wrapper common-table autoheight-table SalesOrderReport" id="style-3">
                            <table className="table table-bordered resizable" id="misOrderReport" ref={salesOrderRef}>
                                <thead>
                                    <tr>
                                        {[
                                            "Sr.no",
                                            "Date",
                                            "Customer (A/C)",
                                            "Order. Ref",
                                            "Net. Amount",
                                            `${company_tax_type}. Total`,
                                            "Gross. Total",
                                            "Paid Total"
                                        ].map((header, idx) => (
                                            <th
                                                key={header}
                                                style={{ width: colWidths[idx], minWidth: 50, position: "relative" }}
                                            >
                                                {header}
                                                {idx < colWidths.length - 1 && (
                                                    <div
                                                        className="th-resizer"
                                                        onMouseDown={(e) => startResizing(idx, e)}
                                                    />
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default SalesOrderReport;
